const getSupplierName = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return business['Company Info'] && business['Company Info']['Company Name'] ? business['Company Info']['Company Name'].toUpperCase() : '';
};

export default getSupplierName;



// WEBPACK FOOTER //
// ./src/utils/print/getSupplierName.js